import { useState } from "react";
import MoTable from "./mo/MoTable";
import MtTable from "./mt/MtTable";

const tabs = [
  {
    id: "mobile-originated",
    label: "Mobile Originated",
  },
  {
    id: "mobile-terminated",
    label: "Mobile Terminated",
  },
];

export default function MobileTabs() {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const currentTab = tabs.find((tab) => tab.id === activeTab);

  return (
    <div className="w-full">
      {/* Tab Navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex overflow-x-auto -mb-px">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-shrink-0 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap sm:px-6 ${
                activeTab === tab.id
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Display MO or MT */}
      {activeTab === "mobile-originated" && <MoTable />}

      {activeTab === "mobile-terminated" && <MtTable />}
    </div>
  );
}
